import React, { useState } from 'react';
import ReusableSidebar from '../../components/sidebar/reusable-sidebar';
import { useUser } from '../../services/contexts/user-context';
import { MainContent } from '../../components/sidebar/sidebar.styles';
import RecruiterProfileCreate from '../on-boarding/components/create-profile';
import Loading from '../../components/loading';
import { useUpdateRecruiterProfile } from '../../services/api/recruiter-api';
import { useNavigate } from 'react-router-dom';

const RecruiterProfileWrapper = () => {
  const { user, isLoading } = useUser();
  const navigate = useNavigate();
  const { mutate: updateRecruiterProfile, isPending: isUpdating } = useUpdateRecruiterProfile();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  const handleToggleSidebar = () => {
    setIsSidebarOpen((isOpen) => !isOpen);
  };

  const handleSave = (formData) => {
    updateRecruiterProfile(formData, {
      onSuccess: () => navigate('/recruiter/home'),
    });
  };

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        selectedPage="profile"
        user={user}
        loading={isLoading}
      />

      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? (
          <Loading />
        ) : (
          <RecruiterProfileCreate
            loading={isUpdating}
            onSave={handleSave}
          />
        )}
      </MainContent>
    </>
  );
};

export default RecruiterProfileWrapper;
